import React, { useState } from "react";

const withFilter = (WrappedComponent: React.ElementType) => (props: any) => {
  const { field, value, onFilterChange } = props;
  const [state, setState] = useState({
    field,
    value
  });
  const handleFilterChange = (newValue: unknown) => {
    setState(prevState => {
      const newState = { ...prevState, value: newValue };
      onFilterChange?.(newState);
      return newState;
    });
  };

  return (
    <WrappedComponent
      handleFilterChange={handleFilterChange}
      activeFilter={state.value}
      {...props}
    />
  );
};

export default withFilter;
